"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular = __importStar(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var CreateReportController = /** @class */ (function () {
    function CreateReportController(
    // @ts-ignore
    $scope, 
    // @ts-ignore
    $filter, 
    // @ts-ignore
    $routeParams, 
    // @ts-ignore
    $window, 
    // @ts-ignore
    $location, 
    // @ts-ignore
    viewResults, 
    // @ts-ignore
    createReportService, 
    // @ts-ignore
    globalOption, 
    // @ts-ignore
    userGlobalOptionsService, 
    // @ts-ignore
    API_ROUTES, 
    // @ts-ignore
    qs, 
    // @ts-ignore
    triggerOverrides, 
    // @ts-ignore
    OVERRIDE_EVENTS, 
    // @ts-ignore
    pageLayoutService, 
    // @ts-ignore
    metricsService, 
    // @ts-ignore
    sanitize) {
        var _this = this;
        this.$scope = $scope;
        this.$filter = $filter;
        this.$routeParams = $routeParams;
        this.$window = $window;
        this.$location = $location;
        this.viewResults = viewResults;
        this.createReportService = createReportService;
        this.globalOption = globalOption;
        this.userGlobalOptionsService = userGlobalOptionsService;
        this.API_ROUTES = API_ROUTES;
        this.qs = qs;
        this.triggerOverrides = triggerOverrides;
        this.OVERRIDE_EVENTS = OVERRIDE_EVENTS;
        this.pageLayoutService = pageLayoutService;
        this.metricsService = metricsService;
        this.sanitize = sanitize;
        this.widgetCount = 0;
        this.CREATE_METHODS = {
            BLANK: 'blank',
            VIEW_RESULTS: 'view-results',
            IMPORT: 'import'
        };
        this.CONVERT_LIMIT = 500;
        this.projectCache = {};
        $scope.$ctrl = this;
        this.translate = this.$filter('translate');
        this.pullingGlobalOptions = true;
        this.userGlobalOptionsService.getUserDefaultOptions()
            // @ts-ignore
            .then(function (defaultOptions) {
            _this.globalReportOptions = defaultOptions;
            _this.form.pageLayout = _this.pageLayoutService.migrateLayout(defaultOptions.pageLayout || {});
            _this.unit = defaultOptions.globalOptions.unit || _this.globalOption.getUnit();
            _this.pullingGlobalOptions = false;
        });
        this.convertLimitNote = this.translate('PR.CONVERT_LIMIT_NOTE', { maxWidgetCount: this.CONVERT_LIMIT });
        this.setupCreateOptions();
    }
    CreateReportController.prototype.setupCreateOptions = function () {
        this.createOptions = [
            {
                value: this.CREATE_METHODS.BLANK,
                label: this.translate('NEW_REPORT'),
                icon: 'icon-blankfile'
            }, {
                value: this.CREATE_METHODS.VIEW_RESULTS,
                label: this.translate('FROM_RESULTS_REPORT'),
                icon: 'icon-reportfile-sm'
            }, {
                value: this.CREATE_METHODS.IMPORT,
                label: this.translate('PR.IMPORT_FROM_QRF'),
                icon: 'icon-xm-upload-large'
            }
        ];
        this.createOptions = this.triggerOverrides({
            event: this.OVERRIDE_EVENTS.CREATE_REPORT_OPTIONS,
            data: this.createOptions,
            sync: true
        });
        this.form = {
            createMethod: this.createOptions[0].value,
            reportName: '',
            // @ts-ignore
            createFrom: null,
            pages: [] // will be handled by filterable-select-menu component
        };
    };
    CreateReportController.prototype.formComplete = function () {
        if (this.isCreateMethod(this.CREATE_METHODS.IMPORT)) {
            // isImportReady defined in prImportController and may not be setup
            // when this is first called.
            return this.isImportReady && this.isImportReady();
        }
        var isCreateFormValid = true;
        if (!this.isCreateMethod(this.CREATE_METHODS.BLANK)) {
            isCreateFormValid = !!this.form.createFrom;
        }
        return isCreateFormValid && !!lodash_1.default.trim(this.form.reportName) && this.hasValidPageLayout();
    };
    CreateReportController.prototype.hasValidPageLayout = function () {
        // The pageLayout can be undefined/empty when first opened.
        return !lodash_1.default.isEmpty(this.form.pageLayout);
    };
    // @ts-ignore
    CreateReportController.prototype.isCreateMethod = function (method) {
        return method === this.form.createMethod;
    };
    // @ts-ignore
    CreateReportController.prototype.setCreateMethod = function (method) {
        this.form.createMethod = method;
    };
    CreateReportController.prototype.getViewResultsProjects = function () {
        var activeSurvey = this.$routeParams.surveyId;
        // @ts-ignore
        return this.viewResults.getViewResultsProjects(activeSurvey).then(function (data) {
            return lodash_1.default.map(data, function (on) {
                return {
                    label: on.description,
                    value: on._id
                };
            });
        });
    };
    // @ts-ignore
    CreateReportController.prototype.getViewResultsProjectLabel = function (projectId) {
        var _this = this;
        if (!projectId) {
            return '';
        }
        var activeSurvey = this.$routeParams.surveyId;
        // @ts-ignore
        if (!this.projectCache[activeSurvey]) {
            // @ts-ignore
            this.projectCache[activeSurvey] = {};
        }
        // @ts-ignore
        if (this.projectCache[activeSurvey][projectId]) {
            // @ts-ignore
            return this.projectCache[activeSurvey][projectId].description;
        }
        // @ts-ignore
        this.viewResults.getViewResultsProject(activeSurvey, projectId).then(function (project) {
            // @ts-ignore
            _this.projectCache[activeSurvey][projectId] = project;
        });
        return '';
    };
    // @ts-ignore
    CreateReportController.prototype.getPages = function (projectId) {
        var _this = this;
        this.loadingPages = true;
        // @ts-ignore
        this.viewResults.getPagesOfReport(projectId).then(function (pages) {
            _this.form.pages = pages;
            lodash_1.default.forEach(_this.form.pages, function (page) {
                page.selected = true;
                if (page.meta && page.meta.hidden) {
                    page.selected = false;
                }
            });
        }).finally(function () {
            _this.loadingPages = false;
        });
    };
    CreateReportController.prototype.createReport = function () {
        var _this = this;
        this.creating = true;
        var form = this.form;
        var sanitizedReportName = this.sanitize.stripHTML(form.reportName);
        var pageLayout = form.pageLayout;
        var activeSurvey = this.$routeParams.surveyId;
        // need to pass stuff
        if (form.createMethod === this.CREATE_METHODS.VIEW_RESULTS) {
            var vrId = form.createFrom;
            var selectedPages = lodash_1.default.filter(form.pages, { selected: true });
            return this.createReportService.createFromViewResults(
            // @ts-ignore
            sanitizedReportName, vrId, pageLayout, this.globalReportOptions, selectedPages).then(function (report) {
                _this.viewNewReport(report);
            });
        }
        else if (form.createMethod === this.CREATE_METHODS.IMPORT) {
            return this.createReportByImport();
        }
        else {
            return this.createReportService.createReport(
            // @ts-ignore
            sanitizedReportName, activeSurvey, pageLayout, this.globalReportOptions).then(function (report) {
                _this.viewNewReport(report);
            });
        }
    };
    // @ts-ignore
    CreateReportController.prototype.viewNewReport = function (report) {
        this.metricsService.newReport(this.form.createMethod);
        this.$window.location = this.qs.append(this.API_ROUTES.VIEW + this.$routeParams.surveyId + '/' + report._id, this.$location.search());
    };
    CreateReportController.prototype.createReportByImport = function () {
        // importContainer defined in prImportController
        this.metricsService.newReport(this.form.createMethod);
        return this.importContainer && this.importContainer();
    };
    CreateReportController.$inject = [
        '$scope',
        '$filter',
        '$routeParams',
        '$window',
        '$location',
        'pr.viewResultsProjects',
        'pr.createReport',
        'pr.globalOptionsService',
        'pr.userGlobalOptionsService',
        'pr.API_ROUTES',
        'prQueryString',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'prPageLayoutService',
        'prMetricsService',
        'prSanitize'
    ];
    return CreateReportController;
}());
exports.default = CreateReportController;
(function (angularModule) {
    angularModule.controller('prCreateReportController', CreateReportController);
})(angular.module('qualtrics.pr'));
